import { createTheme } from '@mui/material/styles';

// Motyw MUI w stylu ulotek: granat jako kolor główny, szeryfowe nagłówki, zaokrąglone karty.
// Kolory jak zmienne --brand-* w index.css (dla obu trybów). MUI potrzebuje tu prawdziwych kolorów,
// a nie zmiennych CSS, bo sam wylicza z nich odcienie (hover, zaznaczenie, kontrast).

const PALETTES = {
    light: {
        navy: '#1c3f58',
        fill: '#1c3f58',
        blue: '#5189b0',
        ink: '#1d1d1f',
        muted: '#5a6670',
        line: '#dbe4ec',
        page: '#ffffff',
        paper: '#ffffff',
    },
    dark: {
        navy: '#9cc4e4',
        fill: '#24557a',
        blue: '#7fb3da',
        ink: '#e6edf3',
        muted: '#9fb1c1',
        line: '#2a3b4b',
        page: '#0d151c',
        paper: '#131e28',
    },
};

const serif = "Georgia, 'Times New Roman', serif";

export function createAppTheme(mode = 'light') {
    const c = PALETTES[mode] || PALETTES.light;
    const accent = c.navy; // akcenty (focus, przełączniki, zaznaczenia) w kolorze tekstu marki
    const serifHeading = { fontFamily: serif, fontWeight: 400, color: c.navy };

    return createTheme({
        palette: {
            mode,
            primary: { main: c.blue, dark: c.fill, contrastText: '#fff' },
            secondary: { main: accent, contrastText: mode === 'dark' ? '#0d151c' : '#fff' },
            text: { primary: c.ink, secondary: c.muted },
            divider: c.line,
            background: { default: c.page, paper: c.paper },
        },
        shape: { borderRadius: 12 },
        typography: {
            h1: serifHeading,
            h2: serifHeading,
            h3: serifHeading,
            h4: serifHeading,
            h5: serifHeading,
            overline: { fontWeight: 700, letterSpacing: '0.18em', color: c.blue },
            button: { textTransform: 'none', fontWeight: 600 },
        },
        components: {
            // Ciemny Paper w MUI dostaje jaśniejszą nakładkę gradientem – wyłączamy, tło bierzemy z palety
            MuiPaper: {
                styleOverrides: {
                    root: { backgroundImage: 'none' },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: 10,
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: accent },
                    },
                    notchedOutline: { borderColor: c.line },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: { '&.Mui-focused': { color: c.navy } },
                },
            },
            MuiDialog: {
                styleOverrides: {
                    paper: { borderRadius: 16, borderTop: `4px solid ${accent}` },
                },
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: { fontFamily: serif, fontWeight: 400, color: c.navy },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: { borderRadius: 999, fontWeight: 600 },
                },
            },
            MuiSwitch: {
                styleOverrides: {
                    switchBase: { '&.Mui-checked': { color: accent } },
                    track: { '.Mui-checked.Mui-checked + &': { backgroundColor: accent } },
                },
            },
            MuiCheckbox: {
                styleOverrides: {
                    root: { '&.Mui-checked': { color: accent } },
                },
            },
        },
    });
}

// Domyślny (jasny) motyw – dla testów i miejsc bez dostępu do kontekstu trybu
const theme = createAppTheme('light');

export default theme;
